import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BaseFormErrorTranslateService {
  translate(_key: string, _errorDetail?: any): string {
    throw Error('FormErrorTranslateService non implémenté');
  }
}
